import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistSetupRoutingModule } from './checklist-setup-routing.module';
import { ChecklistSetupComponent } from './checklist-setup.component';
import { SharedModule } from '../../shared/shared.module';
import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { ChecklistFormComponent } from './checklist-form/checklist-form.component';


@NgModule({
  declarations: [ChecklistSetupComponent, ChecklistItemComponent, ChecklistFormComponent],
  imports: [
    CommonModule,
    ChecklistSetupRoutingModule,
    SharedModule
  ]
})
export class ChecklistSetupModule { }
